import React, { useEffect, useState, RefObject } from 'react'
import { useFormState } from 'react-hook-form'
import { ButtonCta, ButtonCtaProps, ButtonStatus } from '../../../ui-lib/button'
import styles from './form-submit.module.scss'

const getMountedButtonStatus = (isValid: boolean, isSubmitting: boolean) => {
  if (isSubmitting) {
    return ButtonStatus.Loading
  }

  if (!isValid) {
    return ButtonStatus.Disabled
  }

  return ButtonStatus.Active
}

interface FormSubmitButtonProps extends Omit<ButtonCtaProps, 'onClick' | 'status'> {
  download?: {
    ref: RefObject<HTMLAnchorElement>
    href: string
  }
  openInSameTab: boolean | undefined
}

export const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({ download, openInSameTab, ...rest }) => {
  const [hasMounted, setHasMounted] = useState(false)
  const { isValid, isSubmitting } = useFormState()

  useEffect(() => {
    setHasMounted(true)
  }, [])

  // Submit button starts disabled to prevent form submission before javascript has loaded.
  const status = hasMounted ? getMountedButtonStatus(isValid, isSubmitting) : ButtonStatus.Disabled

  return (
    <>
      <ButtonCta {...rest} type="submit" status={status} />
      {download && (
        <a
          className={styles.hidden}
          href={download.href}
          ref={download.ref}
          target={openInSameTab ? undefined : '_blank'}
          rel="noopener noreferrer"
        />
      )}
    </>
  )
}
